/** Génère un identifiant technique à partir du libellé (snake_case ASCII). */
export function slugFromLibelle(raw: string): string {
  const s = (raw || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
  const out = s.substring(0, 64);
  return out || 'champ';
}

export function newRandomId(prefix: string): string {
  return `${prefix}_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 7)}`;
}
